export default {
  order_again: 'Tilaa uudelleen',
  error_messages: {
    product_does_not_exist: 'Tuote ei ole enää saatavilla',
  },
  success_messages: {
    product_added_to_card: 'Tuote lisätty koriin',
  },
};
